import { Component, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RadioCardOption } from '@hit/coverpath-design-system/lib/components/radio-card-group/radio-card-group.component';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { ApplicationService } from '../../../../services/application/application.service';
import { BaseFormComponent } from '../base-form.component';

@Component({
  templateUrl: './agent-submitted-application-type.component.html',
})
export class AgentSubmittedApplicationTypeComponent extends BaseFormComponent {
  private readonly destroy$ = new Subject<void>();
  options: RadioCardOption[] = [
    {
      label: 'Client-submitted',
      value: 'false',
      description: 'The traditional Coverpath experience.',
      summary: `You fill out some part of the application, then send it to the owner to complete. They create an account, complete the application, and sign within Coverpath.`,
    },
    {
      label: 'Advisor-submitted',
      value: 'true',
      description: 'Simplified submission and signature for clients.',
      summary: `You complete the entire application, including the medical questions. The owner consents to underwriting and signs via email. They create an account when their offer is ready.`,
    },
  ];

  applicationTypeForm: FormGroup;
  constructor(protected injector: Injector, private fb: FormBuilder, protected appService: ApplicationService) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    const prop = this.questionItem.prop;
    const value = this.getValue(prop);
    this.applicationTypeForm = this.fb.group({
      isAgentSubmittedApp: [value],
    });

    this.updateFromModel();
    this.applicationTypeForm
      .get('isAgentSubmittedApp')
      .valueChanges.pipe(takeUntil(this.destroy$), distinctUntilChanged())
      .subscribe(async (value) => {
        this.appService.submitValueAndFireTriggers(prop, value === 'true');
      });
  }

  updateFromModel() {
    const prop = this.questionItem.prop;
    const value = this.getValue(prop);
    this.applicationTypeForm.get('isAgentSubmittedApp').setValue(value.toString());
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
